import { Laptop, Moon, Sun } from 'lucide-react';
import { ThemeEnum } from '@/Domain/enum/Theme.enum';

export const themeOptions = [
  { icon: Sun, value: ThemeEnum.Light, labelKey: 'theme.light' },
  { icon: Moon, value: ThemeEnum.Dark, labelKey: 'theme.dark' },
  { icon: Laptop, value: ThemeEnum.System, labelKey: 'theme.system' },
] as const;
